/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import { BrowserRouter, Navigate, Route, Routes, useRoutes } from 'react-router-dom';

import Loader from "./component/Loader";
import { HelmetProvider, Helmet } from "react-helmet-async";

import ThemeProvider from "./contexts/ThemeProvider";
import SidebarProvider from "./contexts/SidebarProvider";
import LayoutProvider from "./contexts/LayoutProvider";

import { Suspense } from 'react';

import { useAuth } from './contexts/AuthContext';
import { LoginForm } from './component/auth/LoginForm';

// import routes from "./routes";
import { DigicapeRoutes } from './routes/DigicapeRoutes';
import { HiTecRoutes } from './routes/HiTecRoutes';
import { AresRoutes } from './routes/AresRoutes';
import { EChartDefaults } from './component/solution/utils/EChartsDefault';
import { StockanywhereRoutes } from './routes/StockanywhereRoutes';

function App() {

	const company: string = `${process.env.REACT_APP_COMPANY}`;
	const { isAuthenticated } = useAuth();

	return (
		<BrowserRouter>

			<HelmetProvider>
				<Helmet defaultTitle="StockAnywhere" />

				<Suspense fallback={<Loader />}>
					<ThemeProvider>
						<SidebarProvider>
							<LayoutProvider>
								<EChartDefaults />
								{isAuthenticated ? (
									<Routes>
										{company.startsWith("ares") && AresRoutes.map((route, index) => (
											<Route key={index} path={route.path} element={route.element}>
												{route.children && route.children.map((childRoute, childIndex) => (
													<Route key={childIndex} path={childRoute.path} element={childRoute.element} />
												))}
											</Route>
										))}										
										{company.startsWith("digicape") && DigicapeRoutes.map((route, index) => (
											<Route key={index} path={route.path} element={route.element}>
												{route.children && route.children.map((childRoute, childIndex) => (
													<Route key={childIndex} path={childRoute.path} element={childRoute.element} />
												))}
											</Route>
										))}
										{company.startsWith("hi-tec") && HiTecRoutes.map((route, index) => (
											<Route key={index} path={route.path} element={route.element}>
												{route.children && route.children.map((childRoute, childIndex) => (
													<Route key={childIndex} path={childRoute.path} element={childRoute.element} />
												))}
											</Route>
										))}		
										{company.startsWith("stockanywhere") && StockanywhereRoutes.map((route, index) => (
											<Route key={index} path={route.path} element={route.element}>
												{route.children && route.children.map((childRoute, childIndex) => (
													<Route key={childIndex} path={childRoute.path} element={childRoute.element} />
												))}
											</Route>
										))}									
									</Routes>
								) : (
									<LoginForm></LoginForm>
								)}
							</LayoutProvider>
						</SidebarProvider>
					</ThemeProvider>
				</Suspense>
			</HelmetProvider>
		</BrowserRouter>
	);
}

export default App;
